export default "__VITE_ASSET__NiqMRixN__"